import { Link } from '@tanstack/react-router'
import styled from 'styled-components'
import { Icon, IconV2 } from 'ui/components/Icon'
import { CSS } from 'ui/helpers'

export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

export const Name = styled.div`
  margin: 0 10px;
  white-space: nowrap;
  ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyM.semiBold)};
`
export const ArrowIcon = styled(Icon)<{ $open: boolean }>`
  transition: all;
  transform: rotate(${(p) => (p.$open ? '180deg' : '0')});
  margin-left: 8px;
  margin-right: 8px;
  svg {
    width: 12px;
    height: 12px;
    fill: ${(p) => p.theme.uiKit.colors.global.grey.grey700};
  }
`

export const MenuItemIcon = styled(IconV2)`
  margin-right: 10px;
  height: 24px;
  color: ${(p) => p.theme.uiKit.colors.global.grey.grey700};
`

export const MenuItem = styled(Link)`
  width: 230px;
  color: ${(p) => p.theme.uiKit.colors.global.grey.grey900} !important;
  text-decoration: none;
  padding: 10px 10px;
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: none;
    color: ${(p) => p.theme.uiKit.colors.global.grey.grey900} !important;
    background: ${(p) => p.theme.uiKit.colors.global.grey.grey100};

    i {
      fill: ${(p) => p.theme.uiKit.colors.theme.brand.primary};
    }
  }
`
